// Configurazione Production
export const productionConfig = {
  ENV: 'production',
  API_URL: 'https://musea.agilae.it/human',
  API_URL_V1: 'https://musea.agilae.it/be',
  DEBUG: false,
  TIMEOUT: 30000,
}; 